import { Controller } from "@hotwired/stimulus";
import { animate } from "animejs";

export default class extends Controller {
  static values = {
    target: Number,
    duration: { type: Number, default: 2.0 },
    decimals: { type: Number, default: 0 },
    easing: { type: String, default: "easeOutExpo" },
  };

  connect() {
    const target = this.targetValue;
    const decimals = this.decimalsValue;
    const el = this.element;
    const fmt = (n) =>
      n.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      el.textContent = fmt(target);
      return;
    }

    const obj = { val: 0 };
    animate(obj, {
      val: target,
      duration: this.durationValue * 1000,
      easing: this.easingValue,
      onUpdate() {
        el.textContent = fmt(obj.val);
      },
      onComplete() {
        el.textContent = fmt(target);
      },
    });
  }
}
